const pkg = state => state.pkg;
const app = state => state.app;
const device = state => state.app.device;
const sidebar = state => state.app.sidebar;
const effect = state => state.app.effect;

export { pkg, app, device, sidebar, effect };



// WEBPACK FOOTER //
// ./client/store/getters.js